module.exports = {"622924100":"城关镇","622924101":"三甲集镇","622924102":"祁家集镇","622924103":"庄窠集镇","622924104":"买家巷镇","622924105":"齐家镇","622924202":"水泉乡","622924203":"官坊乡","622924204":"阿力麻土东乡族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/622924.json
// module id = 2967
// module chunks = 0